


const MAXIMUM_NUMBER_OF_MILLISECONDS_AGO = 30 * 24 * 60 * 60 * 1000 // 30 days

const NUMBER_OF_MILLISECONDS_IN_A_YEAR = 365 * 24 * 60 * 60 * 1000 // 1 year
const NUMBER_OF_MILLISECONDS_IN_A_MONTH = 31 * 24 * 60 * 60 * 1000 // 1 month
const NUMBER_OF_MILLISECONDS_IN_A_DAY = 1 * 24 * 60 * 60 * 1000 // 1 day
const NUMBER_OF_MILLISECONDS_IN_AN_HOUR = 1 * 60 * 60 * 1000 // 1 hour
const NUMBER_OF_MILLISECONDS_IN_A_MINUTE = 60 * 1000 // 1 minute


export {
  MAXIMUM_NUMBER_OF_MILLISECONDS_AGO,
  NUMBER_OF_MILLISECONDS_IN_A_YEAR,
  NUMBER_OF_MILLISECONDS_IN_A_MONTH,
  NUMBER_OF_MILLISECONDS_IN_A_DAY,
  NUMBER_OF_MILLISECONDS_IN_AN_HOUR,
  NUMBER_OF_MILLISECONDS_IN_A_MINUTE
}

